import {
    IFetchPipelineRequest,
    IPipelineStageResponse,
    IWorkspaceCountsResponse
} from '~/types/server.types';
import { WorkspacesAdapter } from '~/services/adapters/workspaces.adapter';
import { ISenderFunctionProps } from '~/components/OneComposer/OneComposerModal/OneComposerModal.types';
import { assign } from 'lodash';
import { toBinaryBase64 } from '~/utils/text.utils';

export class WorkspaceService extends WorkspacesAdapter {
    async fetchPipelineWorkspacesCounts() {
        return super.fetchPipelineWorkspaces<IWorkspaceCountsResponse>({
            allow_db: true,
            counts_only: true
        });
    }

    async fetchRecentPipelineStageWorkspaces({
        per_page,
        stage_id
    }: Required<Pick<IFetchPipelineRequest, 'stage_id' | 'per_page'>>) {
        return super.fetchPipelineWorkspaces<IPipelineStageResponse>({
            page: 1,
            lean_format: true,
            sort_by: 'created_at',
            sort_desc: true,
            per_page,
            stage_id
        });
    }

    async sendReferralEmailToVendor(
        workspaceId: string,
        data: ISenderFunctionProps
    ) {
        const userId = Array.isArray(data.users)
            ? data.users[0]._id
            : data.users._id;

        const { body, ...rest } = data;

        const payload = assign(
            rest,
            {
                body: toBinaryBase64(body),
                email_type: 'vendor_referral'
            },
            rest.isLast && { send_confirmation: true }
        );

        return super.sendReferralEmail(workspaceId, userId, payload);
    }

    async fetchMemberClientReferralEmail(workspaceId: string) {
        return super.fetchMemberClientReferralEmail(workspaceId);
    }
}
